export const MINGU_ENABLED = process.env.REACT_APP_MINGU_ENABLED === 'true';
